import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import "./home.scss";
import { routes } from "../../utils/constants/constant";
import { isAuthenticate } from "../../utils/helpers/helpers";

import Banner from "../../components/banner/Banner";
import WhyChoice from "./components/whyChoice/WhyChoice";
import StartNow from "./components/startNow/StartNow";
import Partner from "./components/partner/Partner";

const Home = (props) => {
  if (isAuthenticate()) {
    props.history.push(routes.DASHBOARD);
    return null;
  }
  return (
    <>
      <Banner />
      <WhyChoice />
      <StartNow />
      <Partner />
    </>
  );
};

export default connect(
  (state) => ({
    isFetching: state.systemReducer.isFetching,
  }),
  {}
)(withRouter(Home));
